import model1 from "../assets/images/model1.png";

export const sliderItems = [
  {
    id: 1,
    img: model1,
    title: "SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: model1,
    title: "AUTUMN COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: model1,
    title: "LOUNGEWEAR LOVE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "JACKETS",
    cat: "Jackets",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "TSHIRTS",
    cat: "Tshirts",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-lama-25868.appspot.com/o/pexels-neosiam-%2B-603022.jpg?alt=media&token=447c8014-778a-4b98-9a72-c5714e1d84e9",
    title: "JEANS",
    cat: "Jeans",
  },
  {
    id: 4,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-lama-25868.appspot.com/o/premium_photo-1673481601147-ee95199d3896.jpg?alt=media&token=7f45ab5a-6fea-4b8a-8d24-9b148722c8f7",
    title: "DRESSES",
    cat: "Dresses",
  },
  {
    id: 5,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-lama-25868.appspot.com/o/Capture.JPG?alt=media&token=a68891b6-c5e9-4aab-b7c1-34faacf47c15",
    title: "LEGGINGS",
    cat: "Leggings",
  },
  {
    id: 6,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-lama-25868.appspot.com/o/freemans-blue-floral-print-jumpsuit.jpg?alt=media&token=af9060a7-0a0c-4418-a7b5-94f10e44a541",
    title: "JUMPSUITS",
    cat: "Jumpsuits",
  },
  {
    id: 7,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-lama-25868.appspot.com/o/1000_F_772517124_knPpXdMpy6yDA314bh2Bvm7Yo5V838Is.jpg?alt=media&token=98f1d9b0-0fd8-481e-9c4c-5a60275994e6",
    title: "HOODIES",
    cat: "Hoodies",
  },
  {
    id: 8,
    img: "https://firebasestorage.googleapis.com/v0/b/ecommerce-lama-25868.appspot.com/o/71Pp9WQiitL._AC_UY1000_.jpg?alt=media&token=8cc73e83-b45f-46e9-bf2e-ac996ab3b09f",
    title: "TROUSERS",
    cat: "Trousers",
  },
];
